








import { IntroductionGuide } from '@/components/guides';
import { Notification } from '@/models';
import { Guide } from '@/models/guides';
import { Actions, typedStore } from '@/store';
import Vue from 'vue';

export default Vue.extend({
  name: 'Guides',
  components: {
    IntroductionGuide: () => Promise.resolve(IntroductionGuide),
  },
  computed: {
    allGuides(): Guide[] {
      return typedStore(this).state.guides.allGuides;
    },
    introductionGuide(): Guide | undefined {
      return this.allGuides.find(n => n.type === 'welcome');
    },
  },
});
